import { useCallback } from "react";

import { usePromise } from "@touchtech/web-hooks";

import { LocalStorageKeys } from "@is/constants";
import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { LocalStorageService, api, createStoreScannerUrl } from "@is/services";
import { RegisteredDevice, Scanner } from "@is/types";

type StoreScannerState = {
  isPending: boolean;
  error: Error | null;
  data: RegisteredDevice | null;
};
async function handleStoreScanner(params: Scanner): Promise<RegisteredDevice> {
  const storeId = LocalStorageService.getItem(LocalStorageKeys.StoreId);
  const deviceId = LocalStorageService.getItem(LocalStorageKeys.DeviceId);

  const url = createStoreScannerUrl({ storeId, deviceId });

  const data = (await api.post(url, params)) as RegisteredDevice;

  return data;
}

export const useStoreScanner = (): [
  StoreScannerState,
  (params: Scanner) => Promise<RegisteredDevice>
] => {
  const [{ isPending, error, data }, dispatch] = usePromise<RegisteredDevice>();

  const { setApiHeaders } = useManageApiHeaders();

  setApiHeaders();

  const saveScanner = useCallback(
    (params: Scanner) => dispatch(handleStoreScanner(params)),
    [dispatch]
  );

  return [{ isPending, error, data }, saveScanner];
};
